import React, { useState, useEffect, Suspense, Fragment, useRef, ReactComponent } from "react";
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import { CSSTransition } from 'react-transition-group';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import AspectRatioBox from "./aspectRatioUtil";
import TextRow from "./textRow";
import Loader from '../static/svg/loader.svg';
import { ReactComponent as ArrowUp } from "../static/svg/arrow-white.svg";
import SwiperCore, { Navigation, Pagination, Mousewheel, EffectFade, Autoplay, FreeMode } from 'swiper';
import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/mousewheel';
import 'swiper/css/effect-fade';

import classNames from 'classnames';

import configData from "../config.json";


SwiperCore.use([Autoplay])
gsap.registerPlugin(ScrollTrigger);

function News(props) {

  function getMedia(path, path_m) {
    let result = props.isMobile ? (path_m ? path_m : path) : path;
    return configData.API_URL + result;
  }
  

  
    let {newsSlug} = useParams();

    const [loaded, setLoaded] = useState(false);
    const [obj, setObj] = useState();
    const [swipers, setSwipers] = useState([]);
    const [headingAr, setHeadingAr] = useState();

    const mediaArray = useRef([]);
    const newsSwiperRef = useRef(null);

    function getFileType(string) {
      let fileType;
  
      var ext = string.split('.').pop();
      switch (ext.toLowerCase()) {
        case "gif":
          fileType = "img";
          break;
        case "png":
          fileType = "img";
          break;
        case "jpg":
          fileType = "img";
          break;
        case "jpeg":
          fileType = "img";
          break;
        case "webp":
          fileType = "img";
          break;
        case "mp4":
          fileType = "vid";
          break;
        case "webm":
          fileType = "vid";
          break;
        case "svg":
          fileType = "svg";
          break;
        default:
          break;
      }
      return fileType;
    }


    const getObj = async() => {
        await axios({
          method: 'get',
          url: configData.API_URL + "/api/news/" + newsSlug + "/"
          })
          .then(response => {
            const dataJSON = response.data;
            console.log('news', dataJSON)
            setObj(dataJSON);
          });
      }



    useEffect(() => {
      console.log('newsSlug', newsSlug)
        newsSlug && getObj();
    }, [newsSlug])

    useEffect(() => { 
      obj && setLoaded(true);
      
      // if (obj && !loaded) {
      //   setTimeout(() => {
      //     if (obj && obj.category && obj.category.heading) {
      //       const container = document.querySelector(".newsTextBlock");
      //       if (container) {
      //         const firstP = container.querySelector("p");
      //         if (firstP) {
      //           firstP.innerHTML = `<strong>${obj.category.heading}</strong> ${firstP.innerHTML}`;
      //         }
      //       }
      //     }
      //   }, 50);
      // }

    }, [obj])


    useEffect(() => {
      props.menuColor('none');
      props.accentColor('#FFFFFF');
      console.log('case study props', props)

      // Page Meta
      document.title = ""
      document.querySelector('meta[name="description"]').setAttribute("content", "");
      document.documentElement.scrollTop = 0;

      return () => {
        swipers.forEach(obj => {
          obj.destoy();
        })
      }

    }, []);

    function addSwiper(obj) {
      let currSwipers = [ ...swipers ];
      currSwipers.push(obj);
      setSwipers(currSwipers);
    }


    function getFile(id, path, fileType) {

      // console.log('getFile', id, path, fileType)
      
      if (!mediaArray.current.includes(path)) {

        let span = document.getElementById('span_' + id);
        if (span) {
          
          let format = span.parentElement.dataset.format;
          let elemCount = span.parentElement.dataset.count;
          let count = elemCount;
          // console.log('elemCount', elemCount);
          if (elemCount === '4') {
            count = 2;
            // console.log('count', count);
          } 

          let copy = [ ...mediaArray.current ];
          copy.push(path);
          mediaArray.current = copy;
          // span.style.width = "800px"
        }

        if (fileType === 'vid') { 
          let target = document.getElementById(id);
          if (target) {
            
            setTimeout(() => {
              target.parentElement.play();
            }, 500);
            // target.parentElement.parentElement.parentElement.classList.add('loaded');
            
            // Update swiper after video loads
            if (newsSwiperRef.current) {
              setTimeout(() => {
                newsSwiperRef.current.updateAutoHeight(300);
              }, 600);
            }
          }
         
        } else {

          const getMediaFile = async (url) => {
            // console.log('mediaArray.current', mediaArray.current, mediaArray.current.includes(url))
            const response = await fetch(url);
            
            const blob = await response.blob() 
            return blob
            
          }
        
          getMediaFile(path)
              .then(result => {
                let target = document.getElementById(id);
                // console.log('result', "#" + id)
                const imageBlob = result
                const imageBase64 = URL.createObjectURL(imageBlob)
                target.setAttribute('src', imageBase64);
                target.parentElement.parentElement.classList.add('loaded');
              })
              .catch(err => {
                // log the specific error
                console.error(`Error -> ${err}`)
              })
          }
      }
    }


  
   

  return (
      <CSSTransition in={loaded} timeout={300} unmountOnExit classNames="pageItem">
      
        <div className={classNames("newsPage", obj && obj.newsfiles.length === 0 && "noFiles")} id="newsPage">

        <div className="swiperColumn">
         <Swiper
              modules={[Navigation,Pagination,Autoplay]}
              initialSlide={0}
              className="swiper-slide"
              slidesPerView={1}
              autoplay={obj && obj.newsfiles && obj.newsfiles.length > 1 ? {
                delay: 3000
              } : false}
              speed={1000}
              loop={obj && obj.newsfiles && obj.newsfiles.length > 1}
              autoHeight={true}
              pagination={{ clickable: true, type: "bullets", el: "#swiperNav_news" }}
              effect={'fade'}
              allowTouchMove={obj && obj.newsfiles && obj.newsfiles.length > 1}
              onSwiper={(swiper) => { 
                newsSwiperRef.current = swiper;
                setTimeout(() => {
                  swiper.update();
                  swiper.updateAutoHeight(300);
                }, 100);
              }}
              onSlideChange={() => { 
                if (newsSwiperRef.current) {
                  setTimeout(() => {
                    newsSwiperRef.current.updateAutoHeight(300);
                  }, 50);
                }
              }}
              >
              {obj && obj.newsfiles && obj.newsfiles.length > 0 && obj.newsfiles.map((item, i) => (
                <SwiperSlide 
                  key={"work_" + i}
                 
                >
                <div className={"caseRowBoxItem"}>
                <div className={`row caseRow`}>
                  {item.caption && <span className="caption"><p>{item.caption}</p></span>}
                  {item.file && (getFileType(item.file) === 'img') && <img src={getMedia(item.file, item.file_m)} alt={item.file_alt} />}
                  {item.file && (getFileType(item.file) === 'vid') && <video poster={Loader} playsInline muted autoPlay loop preload="yes" onLoadedMetadata={() => { 
                    if (newsSwiperRef.current) { 
                      newsSwiperRef.current.update();
                      newsSwiperRef.current.updateAutoHeight(300);
                      // Try again after a brief delay for Safari/production timing
                      setTimeout(() => {
                        newsSwiperRef.current.update();
                        newsSwiperRef.current.updateAutoHeight(300);
                      }, 100);
                    } 
                  }}><source id={"landingRow_" + item.id} src={getMedia(item.file, item.file_m)} preload={"none"} onLoad={getFile("landingRow_" + item.id, getMedia(item.file, item.file_m), 'vid' )} type={props.isMobile?"video/mp4":"video/webm"} /></video>}

              
                </div>
              
              </div>
                </SwiperSlide>
                ))}
              
            </Swiper>  
             <div className="column">
                  <div className="swiperNav" id={"swiperNav_news"}></div>
                </div>     
          </div>

          {obj && <span className="column"><div className="newsBlock">
            <div className="textInner"><span style={{textAlign: 'left'}} className="newsTextBlock" dangerouslySetInnerHTML={{__html: ((obj.text) ? obj.text : "") }} /></div></div></span>}

        </div>
      </CSSTransition>
  );
}

export default News;


// <AspectRatioBox tag={'h2'} classes={['caseHeading']} fonts={props.fonts} content={obj.heading} headingAr={headingAr} />

// {row.heading &&  
//   <div className="heading">
//     <h2><span dangerouslySetInnerHTML={{__html: row.heading}}/></h2> 
//     {row.subheading && <h3><span dangerouslySetInnerHTML={{__html: row.subheading}} /></h3>}
//   </div>
// }